import React from 'react';
import { Link } from 'react-router-dom';
import { Waves, Heart, Leaf, Users } from 'lucide-react';
export function About() {
  const values = [{
    icon: Waves,
    title: 'Born in the Maldives',
    description: 'Every product is curated with island life in mind — built for sun, sand, salt, and snorkeling adventures across our 1,192 islands.'
  }, {
    icon: Leaf,
    title: 'Reef-Friendly',
    description: 'We prioritise reef-safe products and sustainable materials. Our coral reefs are our greatest treasure — we treat them that way.'
  }, {
    icon: Heart,
    title: 'Community First',
    description: 'Beach Shop is locally owned and operated. We work directly with Maldivian artisans and producers wherever possible.'
  }, {
    icon: Users,
    title: 'Built for Everyone',
    description: 'From day-trippers to long-stay residents, our range is designed to suit families, couples, divers, and everyone in between.'
  }];
  return <div className="bg-gray-50 min-h-screen pb-16" data-id="element-201">
      {/* Hero */}
      <section className="bg-white border-b border-gray-200" data-id="element-202">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center" data-id="element-203">
          <span className="text-xs font-semibold uppercase tracking-widest text-red-600" data-id="element-204">
            About Beach Shop
          </span>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-3 mb-4" data-id="element-205">
            Beachwear & accessories, made for the Maldivian sun
          </h1>
          <p className="text-gray-600 text-base sm:text-lg leading-relaxed" data-id="element-206">
            Beach Shop is a locally-owned retailer based in Malé, serving
            residents and visitors across the Maldives with thoughtfully chosen
            beachwear, accessories, and essentials for summer holidays. We're
            small, focused, and obsessive about quality — so you can spend less
            time shopping and more time in the water.
          </p>
        </div>
      </section>

      {/* Our Story */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-207">
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-208">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-209">Our Story</h2>
          <div className="space-y-4 text-gray-600 leading-relaxed" data-id="element-210">
            <p data-id="element-211">
              Beach Shop started in 2018 with a single rack in a guesthouse on
              Maafushi. We noticed that visitors and locals alike were
              constantly searching for the simple things — a quality towel, a
              good pair of sandals, reef-safe sunscreen — but having to choose
              between overpriced resort boutiques and disappointing online
              orders.
            </p>
            <p data-id="element-212">
              Today, we operate from Malé with delivery across the country and a
              point-of-sale presence at select island shops. We've grown, but
              the mission hasn't changed: well-made beach essentials, fair
              prices, and a shopping experience that feels as easy as the lagoon
              outside your door.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-213">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-214">
          What we stand for
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-215">
          {values.map(value => <div key={value.title} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-216">
              <div className="w-10 h-10 rounded-lg bg-red-50 text-red-600 flex items-center justify-center mb-4" data-id="element-217">
                <value.icon className="w-5 h-5" data-id="element-218" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-219">
                {value.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed" data-id="element-220">
                {value.description}
              </p>
            </div>)}
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-221">
        <div className="bg-red-50 border border-red-100 rounded-2xl p-8 text-center" data-id="element-222">
          <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-223">
            Ready to shop?
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-224">
            Browse our curated collection of beachwear, accessories, and
            souvenirs.
          </p>
          <Link to="/shop" className="inline-flex items-center px-6 py-3 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors" data-id="element-225">
            Browse Shop
          </Link>
        </div>
      </section>
    </div>;
}